module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-8"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n           Factuur (" + _vm._s(_vm.invoice.invoice_number) + ") "), _c('i', {
    staticClass: "fa fa-file pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.invoice.invoice_lines), function(invoiceLine) {
    return (invoiceLine.price > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(invoiceLine.description))]), _vm._v(" "), _c('td', [_vm._v("€" + _vm._s(invoiceLine.total))])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-responsive"
  }, [_c('tbody', [_vm._l((_vm.invoice.payments), function(payment) {
    return (payment.payment_type == 'upfront' || payment.payment_type == 'rest') ? _c('tr', [_c('td', {
      staticClass: "col-md-8"
    }, [(payment.payment_type == 'upfront') ? _c('span', [_vm._v("Aanbetaling")]) : _vm._e(), _vm._v(" "), (payment.payment_type == 'rest') ? _c('span', [_vm._v("Restant")]) : _vm._e(), _vm._v(" - " + _vm._s(payment.payment_date) + "\r\n                "), (payment.payment_status == 'paid') ? _c('span', [_vm._v("(Betaald)")]) : _vm._e(), _vm._v(" "), (payment.payment_status == 'open') ? _c('span', [_vm._v("(Open)")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "col-md-2"
    }, [_vm._v("€" + _vm._s(payment.amount))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-md-8"
  }, [_vm._v("Totaal")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("€" + _vm._s(_vm.roundUp(_vm.invoice.total_amount)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Openstaand bedrag")]), _vm._v(" "), _c('th', [_vm._v("€" + _vm._s(_vm.roundUp(_vm.invoice.total_amount - _vm.invoice.amount_paid)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Bedrag betaald")]), _vm._v(" "), _c('th', [_vm._v("€" + _vm._s(_vm.roundUp(_vm.invoice.amount_paid)))])])], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "md-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadInvoiceAttachment(_vm.invoice.id)
      }
    }
  }, [_vm._v("Download factuurbijlage")]), _vm._v(" "), _c('button', {
    staticClass: "md-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadInvoice(_vm.invoice.id)
      }
    }
  }, [_vm._v("Download factuur")])]), _vm._v(" "), _vm._m(1)])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-md-8"
  }, [_vm._v("Omschrijving")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Totaal")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('small', {
    staticClass: "text-info"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ceedc5e"}!./src/templates/reservations/invoice.html
// module id = 535
// module chunks = 1